import React from 'react'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

import { ResidentAppError } from '../../../common/error'

import { Error } from 'components/Error'

interface ErrorHandlerProps {
  children: React.ReactNode
}

export const BuildingViewErrorHandler: React.FC<ErrorHandlerProps> = ({
  children,
}) => {
  const [t] = useTranslation(['errors'])

  const fallbackRender = ({ error }: FallbackProps) => {
    if (error instanceof ResidentAppError) {
      switch (error.errorCode) {
        default:
      }
    }

    return <Error message={t('other.errorLoadingBuilding')} />
  }

  return (
    <ErrorBoundary fallbackRender={fallbackRender}>{children}</ErrorBoundary>
  )
}
